import { render } from "./Cargo.vue?vue&type=template&id=648683d2"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__